import React from "react";
import { useI18n } from "../i18n";
import { useSeo } from "../hooks/useSeo";
import { pathFor } from "../config/site";
import { IMAGES } from "../data/structure";
import { webpageLd, articleLd, breadcrumbLd, personLd } from "../lib/jsonld";
import PageHero from "../components/PageHero";
import EditorialEssay from "../components/EditorialEssay";
import GlobalImpact from "../components/GlobalImpact";
import OfficialLinks from "../components/OfficialLinks";

export default function LegacyPage({ pageKey }) {
  const { lang, d } = useI18n();
  const meta = d.meta.legacy;

  useSeo({
    pageKey,
    title: meta.title,
    description: meta.description,
    jsonLd: [
      webpageLd({ lang, pageKey, title: meta.title, description: meta.description }),
      articleLd({ lang, pageKey, headline: d.essay.heading, description: meta.description }),
      personLd(),
      breadcrumbLd([
        { name: d.ui.nav.home, path: pathFor(lang, "home") },
        { name: d.ui.nav.legacy, path: pathFor(lang, "legacy") },
      ]),
    ],
  });

  return (
    <>
      <PageHero testid="legacy-hero" kicker={d.pillars.impact.title} title={d.meta.legacy.title.split(" |")[0]} intro={d.pages.legacy.intro} image={IMAGES.skyline} />
      <EditorialEssay />
      <GlobalImpact />
      <OfficialLinks />
    </>
  );
}
